<template>
  <div class="reviews-list product-reviews-list container-inner pb-50">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <div v-if="breadcrumbs.length" class="breadcrumbs-div mb-40">
      <breadcrumbs-categories :breadcrumbs="breadcrumbs" class="breadcrumbs-categories" />
    </div>
    <message-area />

    <div class="tile is-ancestor">
      <div class="tile is-1 is-vertical is-parent">
        <div class="tile is-child">
          <div class="mb-10">
            <div class="img-resize img-resize--large mr-50">
              <router-link :to="{ name: 'CustomerProductDetail', params: { id: productId } }">
                <img :src="productImage" alt="..." class="img-thumbnail" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="tile is-parent sss">
        <div class="tile is-child">
          <router-link :to="{ name: 'CustomerShopDetail', params: { shop_id: shopAddress } }" class="c-text-body">
            <span class="subtitle">{{ shopName }}</span>
          </router-link>
          <h5 class="title">
            <router-link :to="{ name: 'CustomerProductDetail', params: { id: productId } }" class="c-text-body">
              <span>{{ productName }}</span>
            </router-link>
          </h5>
          <div class="rating-statistic">
            <RatingIcon :rating="true" :count="ratingGoodTotal"/>
            <RatingIcon :rating="false" :count="ratingBadTotal"/>
          </div>
        </div>
      </div>
    </div>

    <ProductReviews :id="productId" :has-filter="true" :has-rating-statistic="false" pagination-type="number"/>
  </div>
</template>
<style lang="scss" src="./list.scss" scoped>
</style>

<script>
import RatingIcon from '@/components/common/rating-icon.vue';
import MessageArea from '@/components/common/message-area/message-area.vue';
import BreadcrumbsCategories from '@/components/breadcrumbs/breadcrumbs-categories';
import ProductReviews from '@/views/customer/reviews/product/list/list.vue';
import messageUtils from '@/utils/mixins/messageUtils';
import { getCategoryName, truncate } from '@/utils/commonUtil';
import { getProductDetail } from '@/services/product.service';
import { getStatisticReview } from '@/services/productReview.service';

export default {
  name: 'ProductReviewsPage',
  components: {
    MessageArea,
    ProductReviews,
    RatingIcon,
    BreadcrumbsCategories
  },
  mixins: [messageUtils],
  data() {
    return {
      breadcrumbs: [],
      productId: null,
      product: null,
      shopName: '',
      shopAddress: '',
      statistic: null
    };
  },
  computed: {
    productName: function() {
      return this.product && this.product.name && this.product.name.length > 0 ? this.product.name : '';
    },
    categoryName: function() {
      return this.product && this.product.categoryId !== null
        ? getCategoryName(this.product.categoryId, this.$t('categories'))
        : '';
    },
    productImage: function() {
      if (this.product && this.product.image && this.product.image instanceof Array && this.product.image.length > 0) {
        return this.product.image[0];
      } else {
        return require('@/assets/images/goods_default.svg');
      }
    },
    ratingGoodTotal: function() {
      return this.statistic ? this.statistic.numOfGood : '';
    },
    ratingBadTotal: function() {
      return this.statistic ? this.statistic.numOfBad : '';
    },
    showPagination: function() {
      return this.pagination && this.pagination.total > this.pagination.perPage;
    }
  },
  created() {
    this.productId =
      this.$route.params && this.$route.params.productId !== undefined && this.$route.params.productId !== null
        ? parseInt(this.$route.params.productId, 10)
        : null;

    if (this.productId !== null) {
      this.getProductDetail(this.productId);
      this.getStatistic(this.productId);
    }

    this.initBreadcrumbs();
  },
  methods: {
    initBreadcrumbs() {
      this.breadcrumbs.push({ name: 'ホーム', link: '/' });
    },
    resetBreadcrumbs() {
      this.breadcrumbs = [];
    },
    makeBreadcrumbs() {
      this.resetBreadcrumbs();
      this.initBreadcrumbs();

      if (this.categoryName.length) this.breadcrumbs.push({ name: this.categoryName, link: '' });
      if (this.productName.length)
        this.breadcrumbs.push({
          name: truncate(this.productName, 20),
          link: `/customer/product/detail/${this.productId}`
        });
      this.breadcrumbs.push({ name: 'すべてのレビュー', link: '' });
    },
    async getProductDetail(id) {
      this.loading++;

      const { status, result } = await getProductDetail(id);

      if (status) {
        this.product = result.data;
        this.shopName = result.data.shopName;
        this.shopAddress = result.data.owner;
        this.makeBreadcrumbs();
      }

      this.loading--;
    },
    async getStatistic(id) {
      this.loading++;

      const { status, result } = await getStatisticReview(id);

      if (status) {
        this.statistic = result.data;
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;
    }
  }
};
</script>
